import React, { useEffect, useState } from "react";
import "./Popular_Tags.css";
import { BlogById } from "../../../../utils/apis/blog/Blog";

const Popular_Tags = ({ blogId }) => {
  const [populartag, setPopularTag] = useState([]);

  const getPopularTag = async () => {
    const res = await BlogById(blogId);

    if (res?.success) {
      setPopularTag(res?.data?.pop_tag_id || []);
    }
  };

  useEffect(() => {
    if (blogId) {
      getPopularTag();
    }
  }, [blogId]);

  if (!populartag || populartag.length === 0) {
    return null;
  }

  return (
    populartag?.length > 0 && (
      <section className="Popular_Tags">
        <div className="container">
          <h5 className="Popular_Tags_title">Popular Tags</h5>

          <div className="tags_container">
            {populartag
              ?.filter((item) => item?.label) //remove invalid items
              .map((item, index) => (
                <div className="tags_div" key={`${item?.value}-${index}`}>
                  <p className="tags_label">{item?.label}</p>
                </div>
              ))}
          </div>

          <hr />
        </div>
      </section>
    )
  );
};

export default Popular_Tags;
